import { Link } from 'react-router-dom';
import { Calendar, ExternalLink } from 'lucide-react';

interface MeetingContentItem {
  source_type: string;
  source_id: string;
  tagged_text?: string;
  tag_name: string;
  tag_color: string;
  note_tag_id?: string;
}

interface MeetingGroup {
  key: string;
  meeting_instance_id: string;
  meeting_date: string;
  series_name: string;
  series_id: string;
  items: MeetingContentItem[];
}

function formatDate(dateStr: string): string {
  const d = new Date(dateStr + (dateStr.includes('T') ? '' : 'T00:00:00'));
  return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' });
}

export function MeetingGroupCard({ group }: { group: MeetingGroup }) {
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Calendar size={14} className="text-text-muted" />
        <span className="text-xs font-medium text-text-secondary">
          {formatDate(group.meeting_date)}
        </span>
        <span className="text-xs text-text-muted">&mdash;</span>
        <Link
          to={`/meetings/${group.series_id}/${group.meeting_instance_id}`}
          className="text-xs text-accent hover:text-accent-hover flex items-center gap-1"
        >
          {group.series_name} <ExternalLink size={10} />
        </Link>
      </div>

      {group.items.map((item) => (
        <div key={item.note_tag_id} className="bg-bg-card border border-border rounded-lg px-4 py-3">
          <div className="flex items-start justify-between gap-2">
            <div className="flex-1 min-w-0">
              <p className="text-sm text-text-primary whitespace-pre-wrap">{item.tagged_text}</p>
            </div>
            <span
              className="text-xs px-1.5 py-0.5 rounded-full flex-shrink-0"
              style={{ backgroundColor: item.tag_color + '20', color: item.tag_color }}
            >
              {item.tag_name}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}

export type { MeetingGroup, MeetingContentItem };
